import { render, staticRenderFns } from "./FooterMobile.vue?vue&type=template&id=39c3d50e&scoped=true"
import script from "./FooterMobile.vue?vue&type=script&lang=js"
export * from "./FooterMobile.vue?vue&type=script&lang=js"
import style0 from "./FooterMobile.vue?vue&type=style&index=0&id=39c3d50e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c3d50e",
  null
  
)

export default component.exports